import {IFieldChangeData, IFieldData} from '../constants/models';

// Regex Dictionary
// eslint-disable-next-line no-useless-escape
const onlyLetters = new RegExp('^[a-zA-Z ]{2,}$');
const regexEmailPattern = new RegExp('^(([^<>()[\\]\\.,;:\\s@"]+(\\.[^<>()[\\]\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$');

export default function isPasswordValid(password: string) {
  const reg = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  return reg.test(password);
}

export const toIFieldData = (fieldData: IFieldChangeData, rest?: object): IFieldData =>
  ({fieldName: fieldData.fieldName, value: fieldData.value, error: '', ...(rest || {})});


// Main Validation Function
export const validateFields = (fieldData: IFieldChangeData): IFieldData => {
  switch (fieldData.fieldName) {
    case 'confirmPassword':

      if (!isPasswordValid(fieldData.value))
        return toIFieldData(fieldData, {error: 'Use 8 or more characters with a mix of uppercase and lowercase letters, numbers & symbols'});

      if (fieldData.value !== fieldData.payload?.password)
        return toIFieldData(fieldData, {error: "Passwords don't match"});
      break;

    case 'password':
      if (!isPasswordValid(fieldData.value))
        return toIFieldData(fieldData, {error: 'Use 8 or more characters with a mix of uppercase and lowercase letters, numbers & symbols'});
      break;
    case 'resetPasswordUser':
    case 'userName':
      if (!regexEmailPattern.test(fieldData.value))
        return {fieldName: fieldData.fieldName, value: fieldData.value, error: 'Invalid User Name'};
      break;

    case 'memberFirstName':
    case 'memberLastName':
      if (!onlyLetters.test(fieldData.value))
        return toIFieldData(fieldData, {error: 'Invalid Member Name'});
      break;

    case 'email':
      if (!regexEmailPattern.test(fieldData.value))
        return toIFieldData(fieldData, {error: 'Invalid email address'});
      break;

    default:
      if (!onlyLetters.test(fieldData.value))
        return toIFieldData(fieldData, {error: 'Invalid input'});
      break;

  }
  return toIFieldData(fieldData);
}
